export default {
  toasts: {
    verification_pending: 'Verificarea dvs. este încă în așteptare',
  },
};
